import {
  Button,
  ButtonProps,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  Modal,
  Paper,
} from '@material-ui/core'
import React, { useState } from 'react'
import { strings } from './strings'

interface ConfrimButtonProps extends ButtonProps {
  text: string
  message?: string
}

export function ConfirmButton(props: ConfrimButtonProps) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const { text, message, onClick: handleClick, ...btnProps } = props

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handlePerform = (event: any) => {
    handleClose()
    if (handleClick) handleClick(event)
  }

  return (
    <>
      <Button {...btnProps} onClick={handleClickOpen}>
        {text}
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Paper className={classes.modal}>
          <DialogContent>
            <DialogContentText>{message ? message : strings.youSure}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              type="button"
              size="small"
              variant="outlined"
              color="secondary"
            >
              {strings.no}
            </Button>
            <Button
              onClick={handlePerform}
              type="button"
              size="small"
              variant="outlined"
              color="primary"
              autoFocus
            >
              {strings.yes}
            </Button>
          </DialogActions>
        </Paper>
      </Modal>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      width: `calc(100% - ${theme.spacing(2)}px)`,
      transform: 'none',
      top: 0,
      left: 0,
      margin: theme.spacing(1),
    },
    '&:focus': {
      outline: 'none',
    },
  },
}))
